import { useEffect } from 'react';

/**
 * scans a rendered component and injects surrounding <sup></sup> tags in the
 * innerhtml of the element that contains the provided string (i.e. ®)
 */
const useSuperscriptTags = (character: string, ancestorId: string): void => {
    useEffect(() => {
        const mainElements = document.getElementById(ancestorId)?.getElementsByTagName('*');
        const hasCharacter = document.getElementById(ancestorId)?.textContent?.includes(character);

        if(mainElements && hasCharacter){
            const elements = Array.from(mainElements).filter(item =>{
                return item.tagName.toLowerCase() !== 'sup';
            });
            elements.forEach(element => {
                let charLocation;
                if(element.getElementsByTagName('*').length === 0){
                    charLocation = element.textContent?.search(character);
                }
                let updatedHtml;
                if(charLocation && charLocation > -1) {
                    updatedHtml = element.innerHTML?.replaceAll(character, `<sup>${character}</sup>`);
                }
                if(updatedHtml) {
                    element.innerHTML = updatedHtml;
                }
            });
        }
    });
};

export default useSuperscriptTags;
